module.exports = __webpack_public_path__ + "img/167.e065b89e.jpg";